export default function Worker_fn() {
  return new Worker(__webpack_public_path__ + "js/monitoringWorker.b7ec5695.worker.js");
}
